import React from 'react'
import { FormSpy } from 'react-final-form'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'

import { Heading } from '@infura/packages.ui/Heading'
import { Text } from '@infura/packages.ui/Text'
import { Tooltip } from '@infura/packages.ui/Tooltip'

import { SurveyInputOptions } from 'components/onboardingWelcome'
import type { ISurveyQuestions } from 'components/onboardingWelcome'

export const QuestionError = ({ id }) => (
  <FormSpy subscription={{ errors: true, touched: true }}>
    {({ errors, touched }) =>
      errors?.[id] &&
      touched?.[id] && (
        <div className='flex items-center'>
          <FontAwesomeIcon className='mr-2 text-red-400' icon={faExclamationTriangle} />
          <Text as='span' className='font-body block text-sm text-red-400' theme='sm'>
            {errors?.[id]}
          </Text>
        </div>
      )
    }
  </FormSpy>
)

const Question = ({
  columns,
  description,
  id,
  options,
  required,
  title,
  titleAlt,
  tooltip,
  type,
  userKeys
}: ISurveyQuestions) => {
  const keysLength = Object.values(userKeys || {}).length
  const isShowApiKeyTitle = type !== 'setKey' || (type === 'setKey' && keysLength !== 1)
  const dispayedTitle = titleAlt && keysLength > 1 ? titleAlt : title

  return (
    <div className='m-auto flex flex-col'>
      {isShowApiKeyTitle ? (
        <div className={`flex flex-col justify-between px-6 py-8 pb-0`}>
          <span className='flex justify-between'>
            <Heading className={`mb-2`} theme='section'>
              {dispayedTitle}
              {required ? <span className='text-primary ml-1'>*</span> : null}
              {tooltip ? <Tooltip className='z-10' content={tooltip} /> : null}
            </Heading>
            <QuestionError id={id} />
          </span>
          {description ? <p className='mb-4 max-w-[400px]'>{description}</p> : null}
        </div>
      ) : null}
      <SurveyInputOptions columns={columns} options={options} section={id} type={type} userKeys={userKeys} />
    </div>
  )
}

export default Question
